import { PayloadAction } from "@reduxjs/toolkit";
import { FinanceState } from "../../models/FinanceState";
import { GetPlannedMoneyPayload } from "../../payload/GetPlannedMoney/GetPlannedMoneyPayload";

const getPlannedMoneyFetch = (state: FinanceState, action: PayloadAction<GetPlannedMoneyPayload>) => {
    state.isLoading = true;
}

export default getPlannedMoneyFetch;